export const LANGUAGES = {
  en: {
    lang: 'en',
    langTitle: 'English',
    url: 'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/grievance_redressal/english.pdf&embedded=true'
  },
  hindi: {
    lang: 'hindi',
    langTitle: 'Hindi',
    url: 'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/grievance_redressal/hindi.pdf&embedded=true'
  },
  telugu: {
    lang: 'telugu',
    langTitle: 'Telugu',
    url: 'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/grievance_redressal/telugu.pdf&embedded=true'
  },
  tamil: {
    lang: 'tamil',
    langTitle: 'Tamil',
    url: 'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/grievance_redressal/tamil.pdf&embedded=true'
  },
  punjabi: {
    lang: 'punjabi',
    langTitle: 'Punjabi',
    url: 'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/grievance_redressal/punjabi.pdf&embedded=true'
  },
  marathi: {
    lang: 'marathi',
    langTitle: 'Marathi',
    url: 'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/grievance_redressal/marathi.pdf&embedded=true'
  },
  kannada: {
    lang: 'kannada',
    langTitle: 'Kannada',
    url: 'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/grievance_redressal/kannada.pdf&embedded=true'
  },
  gujarati: {
    lang: 'gujarati',
    langTitle: 'Gujarati',
    url: 'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/grievance_redressal/gujarati.pdf&embedded=true'
  },
  bengali: {
    lang: 'bengali',
    langTitle: 'Bengali',
    url: 'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/grievance_redressal/bengali.pdf&embedded=true'
  }
};
